import {
  useFloating,
  offset,
  flip,
  shift,
  autoUpdate
} from "@floating-ui/react";
import { useState } from "react";
import {createPortal} from "react-dom";

export default function ReportCardTooltip({ children, content, className }) {
  const [open, setOpen] = useState(false);

  const { refs, floatingStyles } = useFloating({
    strategy: "fixed",
    open,
    onOpenChange: setOpen,
    middleware: [
      offset(1),
      flip(),
      shift()
    ],
    whileElementsMounted: autoUpdate
  });

  return (
    <>
      <div
        ref={refs.setReference}
        onMouseEnter={() => setOpen(true)}
        onMouseLeave={() => setOpen(false)}
        className={className}
      >
        {children}
      </div>

      {open && createPortal(
        <div
          ref={refs.setFloating}
          style={{
            ...floatingStyles,
            backgroundColor: "#ffffff",
            borderRadius: "8px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
          }}
        >
          {content}
        </div>,
        document.body
      )}
    </>
  );
}